import React, { useEffect, useRef } from 'react'
import styled from '@emotion/styled'
import { throttle } from 'lodash'
import { quadtree } from 'd3-quadtree'

import * as THREE from 'three'

const Container = styled.div`
  position: absolute;
  display: flex;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.blueDeep};
`

export default function (props) {
  const { manager, onClick, onMouseOver, zoom } = props
  const threeRefs = props.threeRefs.current
  const containerRef = useRef()
  const mouseRef = useRef({
    x: 0, y: 0
  })

  useEffect(() => {
    let iterationPromise
    let last
    const currentNode = containerRef.current

    const onMouseMove = throttle(
      (e) => {
        if (!threeRefs) return

        mouseRef.current = {
          x: e.offsetX,
          y: e.offsetY
        }

        var size = new THREE.Vector3()
        threeRefs.gl.getSize(size)
        var vec = new THREE.Vector3()
        var pos = new THREE.Vector3()

        vec.set(
          (mouseRef.current.x / size.x) * 2 - 1,
          -(mouseRef.current.y / size.y) * 2 + 1,
          0.5
        )

        vec.unproject(threeRefs.camera)
        vec.sub(threeRefs.camera.position).normalize()
        var distance = -threeRefs.camera.position.z / vec.z
        pos.copy(threeRefs.camera.position).add(vec.multiplyScalar(distance))

        const quadtreeInstance = quadtree()

        manager.selectedNodes.forEach((id, i) => {
          quadtreeInstance.add([
            manager.nodePositions[i * 3],
            manager.nodePositions[i * 3 + 1],
            id
          ])
        })

        const offset = 2 + (3 * ((10 - (zoom - 0.5)) / 10))

        const result = quadtreeInstance.find(
          pos.x, pos.y, offset
        )
        const resultValue = result
          ? result[2]
          : result

        onMouseOver(resultValue)
        last = resultValue
      },
      1000 / 30
    )

    const onClickFn = () => {
      onClick(last)
    }

    currentNode.addEventListener('mousemove', onMouseMove, false)
    currentNode.addEventListener('click', onClickFn, false)

    return () => {
      currentNode.removeEventListener('mousemove', onMouseMove, false)
      currentNode.removeEventListener('click', onClickFn, false)
      iterationPromise && iterationPromise.abort()
    }
  }, [threeRefs, containerRef, manager.nodePositions, manager.selectedNodes, onMouseOver, zoom, onClick])

  useEffect(() => {
    const currentNode = containerRef.current

    const onMouseLeave = (e) => {
      onMouseOver(null)
    }

    currentNode.addEventListener('mouseleave', onMouseLeave, false)

    return () => {
      currentNode.removeEventListener('mouseleave', onMouseLeave, false)
    }
  }, [containerRef, onMouseOver])

  return (
    <Container ref={containerRef}>
      {props.children}
    </Container>
  )
}
